module.exports = __webpack_public_path__ + "static/img/3_1_3_2.2a48bd82.jpg";